module.exports = __webpack_public_path__ + "static/caisse-2193417c1aef5bf1c6c23519b27b561d.png";